module.exports = __webpack_public_path__ + "static/logotipi-eu-fc54f70d84122a66e1152baafe22b8da.png";